import type { EquipmentCostCategoryItem, EquipmentCostEditableTree } from 'ab-viewModels/editableTree.viewModel';

export const fromTree = (leaf: EquipmentCostEditableTree): EquipmentCostCategoryItem => {
	return {
		level: leaf.level,
		nodeId: leaf.nodeId,
		name: leaf.name,
		color: leaf.color,
		parents: leaf.parents,
	};
};
